module.exports = __webpack_public_path__ + "e12f8442747f8aaff26a477a7cf8470a.MP3";